import localforage from 'localforage'
import _ from 'lodash'

class Fournisseur {
    getList(callback) {
        localforage
            .getItem('listFournisseurs')
            .then(fournisseurs => {
                callback(_.sortBy(JSON.parse(fournisseurs), ['nom']))
            }).catch()
    }
}

export default Fournisseur



// WEBPACK FOOTER //
// ./src/js/models/Fournisseur.js